import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLockOutlineComponent } from "./med-icon-lock-outline.component";

@NgModule({
  declarations: [
    MedIconLockOutlineComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLockOutlineComponent,
  ],
})
export class MedIconLockOutlineModule { }
